module.exports = __webpack_public_path__ + "img/pc-1595125_1920.5e66c9a5.jpg";